import type { ServiceMode } from 'state/service-mode';
import { relativeRoutes } from 'utils/routing';

const SERVICE_MODE_HEADER_ANCILLARY_ROUTE = relativeRoutes.storeLocator;

// should return true (to show service mode header) if there is a service mode selected
// and the user is not on the store locator view
export const shouldShowServiceModeHeader = (pathname: string, serviceMode: ServiceMode | null) =>
  Boolean(serviceMode) && !pathname.includes(SERVICE_MODE_HEADER_ANCILLARY_ROUTE);
